require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./node_modules/.2.5.7@core-js/library/modules/es7.symbol.observable.js
// module id = 466
// module chunks = 1